import { c, a } from './chunk-VSVXN4DE.mjs';
import { Children, cloneElement } from 'react';

var W=d=>{var e=d,{children:i}=e,n=c(e,["children"]);return Children.map(i,h=>cloneElement(h,a({},n)))};

export { W as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LL7VUUUP.mjs.map